import { Pipe, PipeTransform } from '@angular/core';
import { toString } from 'lodash';
import { Nullable } from '../models/app.model';

// Define valid options as constants
const VALID_STYLES = ['decimal', 'currency', 'percent', 'unit'] as const;
const VALID_CURRENCY_DISPLAYS = ['symbol', 'narrowSymbol', 'code', 'name'] as const;

@Pipe({
    name: 'numberFormat',
    standalone: true,
})
export class NumberFormatPipe implements PipeTransform {
    transform(
        value: Nullable<number>,
        style: 'decimal' | 'currency' | 'percent' | 'unit' = 'decimal',
        currencyDisplay: 'symbol' | 'narrowSymbol' | 'code' | 'name' = 'code',
        currency: string = 'VND'
    ): string {
        // Default value for invalid inputs
        if (!value && value !== 0) {
            value = 0;
        }

        // Validate style and currencyDisplay
        if (!VALID_STYLES.includes(style)) {
            style = 'decimal'; // fallback to default
        }
        if (!VALID_CURRENCY_DISPLAYS.includes(currencyDisplay)) {
            currencyDisplay = 'code'; // fallback to default
        }

        return new Intl.NumberFormat('vi-VN', {
            style,
            currency,
            maximumFractionDigits: 0,
            currencyDisplay,
        }).format(value as number);
    }
}
